<template>
  <div class="research">
    <h1 v-bg-typography="'h1'">Test Setups</h1>

    <bg-new-list
      v-if="!isLoading"
      @actionClick="handleActions"
      :headers="headers"
      :items="testSetupsList"
      :actions="actions"
      :actionPerms="true"
    />
    <h2
      v-if="!isLoading && testSetupsList.length == 0"
      v-bg-typography="'h4'"
      :style="{ marginTop: '150px' }"
    >
      There are no active test setups
    </h2>

    <bg-loader :dark="true" v-if="isLoading"></bg-loader>
  </div>
</template>

<style scoped>
.search-filters {
  display: flex;
}
.filter {
  margin-right: 12px;
}
.filter-container {
  display: flex;
  flex-direction: row;
}
.search-input {
  max-width: 300px;
  margin-right: 140px;
}
</style>

<script>
import BgNewList from "@/components/bg-new-list";
import BgTypography from "@/directives/bg-typography";
import BgLoader from "@/components/bg-loader";
import BgDayMonthYear from "@/filters/bg-day-month-year";
import moment from "moment";
import API from "@/api";
import { mapState } from "vuex";

export default {
  name: "testSetups",
  components: {
    BgNewList,
    BgLoader,
  },
  directives: {
    BgTypography,
  },
  computed: {},
  methods: {
    handleActions(user) {
      console.log(user);
    },
  },
  data() {
    return {
      isLoading: true,
      animate: true,
      testSetupsList: [],
      headers: [
        { label: "Name", value: "name" },
        { label: "Ip", value: "ip" },
        { label: "Eeg", value: "status", format: (value) => value["eeg"] },
        { label: "Eye", value: "status", format: (value) => value["eye"] },
        { label: "Mouse", value: "status", format: (value) => value["mouse"] },
        { label: "Tapp", value: "status", format: (value) => value["tapp"] },
        {
          label: "Recorder",
          value: "status",
          format: (value) => value["recorder"],
        },
        { label: "Redis", value: "status", format: (value) => value["redis"] },
        {
          label: "Last update",
          value: "updated_at",
        },
      ],
      actions: [],
    };
  },
  mounted() {
    API.testSetups.getTestSetups().then((res) => {
      this.isLoading = false;
      this.testSetupsList = res.data.test_setups;
    });
  },
};
</script>
